import { surveysConstants } from '@constants/surveys';
import { surveyService } from '@services';

export const surveysActions = {
    getAll,
};

function getAll() {
    return dispatch => {
        dispatch(request());
        return surveyService.getAll().then(
            data => dispatch(success(data.items, data.totalCount)),
            error => dispatch(failure(error)),
        );
    };
}

function request() {
    return { type: surveysConstants.SURVEYS_REQUEST };
}

function success(data, totalCount) {
    return { type: surveysConstants.SURVEYS_SUCCESS, data, totalCount };
}

function failure(message) {
    return { type: surveysConstants.SURVEYS_ERROR, message };
}
